import React, { ReactElement } from 'react'

import { Flex, Icon, theme } from '@mindfulchefuk/design-system'
import {
  SpicinessLevel,
  TRecipeClaim,
} from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeModalClaimLozenge } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalClaimLozenge'
import { isMobileDevice } from '@mindfulchefuk/utils/isMobileDevice'

type TRecipeModalClaims = {
  claims: TRecipeClaim[]
  spicinessLevel: SpicinessLevel
}

export const RecipeModalClaims = ({
  claims,
  spicinessLevel,
}: TRecipeModalClaims): ReactElement => {
  const mappingArray = new Array(spicinessLevel).fill(null)
  const ariaLabel =
    spicinessLevel > 0 ? `${spicinessLevel.toString()} chilli icons` : null

  const isOnMobile = isMobileDevice()

  const claimsToDisplay = isOnMobile ? claims.slice(0, 3) : claims.slice(0, 15)

  return (
    <Flex
      width="100%"
      justifyContent="flex-start"
      flexDirection="row"
      wrap="wrap"
      alignContent="flex-start"
      maxWidth={['288px', '415px']}
      maxHeight={448}
      mb={[12, 0]}
      marginX={[16, 24]}
      mt={12}
    >
      {claimsToDisplay.map((claim) => (
        <RecipeModalClaimLozenge {...claim} key={claim.name} />
      ))}
      {isOnMobile && spicinessLevel > 0 && (
        <Flex aria-label={ariaLabel} justifyContent="center" mt={6}>
          {mappingArray.map((_value, index) => (
            <Icon
              color={theme.colors.pepper}
              data-testid="chilli"
              // eslint-disable-next-line react/no-array-index-key
              key={`chilli ${index}`}
              marginLeft={-8}
              size={20}
              type="chilli"
            />
          ))}
        </Flex>
      )}
    </Flex>
  )
}
